import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from 'antd';

const StyledLink = styled(Link)`
  font-size: 1.3rem;
`;

export const TitleCell = ({ route, title }) => (
  <StyledLink to={route}>{title}</StyledLink>
);

TitleCell.propTypes = {
  route: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export const CreatorCell = ({ email, updatedAt }) => (
  <div>
    <p>{email}</p>
  </div>
);

CreatorCell.propTypes = {
  email: PropTypes.string.isRequired,
  updatedAt: PropTypes.number.isRequired,
};

const StyledActions = styled.div`
  display: flex;
  .item {
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-right: 40px;
  }

  .item i {
    font-size: 1.8rem;
    color: #4e81bd;
    cursor: pointer;
  }

  .item p {
    margin-top: 8px;
    margin-bottom: 0;
    padding-bottom 0;
    font-weight: 400;
  }
`;

export const ActionCell = ({
  id,
  onCopy,
  onDelete,
  creatorUid,
  uid,
  favorite,
  onFavorite,
  isPublic,
  onSetPublic,
}) => (
  <StyledActions>
    <div className="item">
      <Icon
        onClick={() => onFavorite(id)}
        type="star"
        style={{ color: favorite ? '#FFD700' : '#c3c3c3' }}
      />
      <p>FAVORITE</p>
    </div>
    <div className="item">
      <Icon type="copy" onClick={() => onCopy(id)} />
      <p>COPY</p>
    </div>
    {uid === creatorUid && (
      <div className="item">
        <Icon
          type={isPublic ? 'check-circle-o' : 'close-circle-o'}
          onClick={() => onSetPublic(id)}
        />
        <p>{isPublic ? 'PUBLIC' : 'PRIVATE'}</p>
      </div>
    )}
    {uid === creatorUid && (
      <div className="item">
        <Icon type="delete" onClick={() => onDelete(id)} />
        <p>DELETE</p>
      </div>
    )}
  </StyledActions>
);

ActionCell.propTypes = {
  id: PropTypes.string.isRequired,
  onCopy: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  uid: PropTypes.string.isRequired,
  creatorUid: PropTypes.string.isRequired,
  favorite: PropTypes.bool.isRequired,
  onFavorite: PropTypes.func.isRequired,
  isPublic: PropTypes.bool.isRequired,
  onSetPublic: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/ListTableCells/ListTableCells.js